import { useFetch, useLogo } from '../../hooks';
import { getCourse, getEnrollment } from '../../api';

export type { CourseType, EnrollmentType, LessonType } from '../../api';

export const useCourse = (enrollmentId: string) => {
  const {
    data: enrollment,
    refresh: refreshEnrollment,
    intializing: loadingEnrollment,
  } = useFetch(() => getEnrollment(enrollmentId), [enrollmentId]);

  const courseId = enrollment?.courseId;
  const { intializing: loading, data } = useFetch(
    () => (courseId ? getCourse(courseId) : null),
    [courseId],
    { skip: !enrollment?.id }
  );

  useLogo(data);

  return {
    enrollment,
    course: data,
    loading: loading || loadingEnrollment,

    refreshEnrollment,
  };
};
